import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { Apps } from '@mui/icons-material';
import { CopyableId } from './CopyableId';

export interface ProductCellProps {
  productId?: string | null | undefined;
  name?: string | null | undefined;
  avatarUrl?: string | null | undefined;
  size?: 'small' | 'medium' | undefined;
}

const sizeMap = { small: 28, medium: 36 };

function initialsFromName(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .filter(part => !['de', 'da', 'do', 'dos', 'das'].includes(part.toLowerCase()));
  const initials = parts
    .slice(0, 2)
    .map(part => part.charAt(0).toUpperCase())
    .join('');
  return initials || name.charAt(0).toUpperCase();
}

export const ProductCell: React.FC<ProductCellProps> = ({
  productId,
  name,
  avatarUrl,
  size = 'small'
}) => {
  const id = productId?.trim() || '';
  const displayName = name?.trim() || id || 'Produto não informado';
  const avatarSize = sizeMap[size];
  const hasAvatar = typeof avatarUrl === 'string' && avatarUrl.trim() !== '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
      <Avatar
        {...(hasAvatar ? { src: avatarUrl.trim() } : {})}
        sx={{
          width: avatarSize,
          height: avatarSize,
          bgcolor: hasAvatar ? undefined : 'secondary.main',
          color: hasAvatar ? undefined : 'secondary.contrastText',
          fontSize: size === 'small' ? 12 : 14,
          fontWeight: 700
        }}
      >
        {!hasAvatar &&
          (displayName ? (
            initialsFromName(displayName)
          ) : (
            <Apps sx={{ fontSize: size === 'small' ? 16 : 20 }} />
          ))}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="body2" fontWeight={500} noWrap>
          {displayName}
        </Typography>
        {id && (
          <Typography variant="caption" color="text.secondary" noWrap display="block">
            Produto: <CopyableId value={id} label="productId" />
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ProductCell;
